module.exports = __webpack_public_path__ + "static/media/USYGY100093.1c2a0c9b.jpg";